import type { Vendor, PropertyVendor } from '../types/providerSearch';

export const mockVendors: Vendor[] = [
  // Minnesota Vendors
  {
    id: 'V001',
    name: 'AutoFix Pro',
    providerId: 'P001',
    specialityCodeSvc: 'CARDIOLOGY',
    taxIdentificationNbr: 123456789,
    tiesId: 987654321,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V001',
    vendorTypeCode: 11,
    vendorSpecializations: 'Automotive Repair',
    phone: '6125551234',
    address: {
      street: '123 Main St',
      city: 'Minneapolis',
      state: 'MN',
      zipCode: '55401'
    },
    coordinates: {
      lat: 44.9778,
      lon: -93.2650
    },
    services: ['Oil Change', 'Brake Repair', 'Engine Diagnostics'],
    status: 'Active',
    isSelected: false
  },
  {
    id: 'V002',
    name: 'QuickRepair LLC',
    providerId: 'P002',
    specialityCodeSvc: 'TRANSMISSION',
    taxIdentificationNbr: 234567890,
    tiesId: 876543210,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'Y',
    suppressionComment: 'no comments',
    vendorId: 'V002',
    vendorTypeCode: 11,
    vendorSpecializations: 'Transmission and AC Repair',
    address: {
      street: '456 Oak Ave',
      city: 'Minneapolis',
      state: 'MN',
      zipCode: '55401'
    },
    coordinates: {
      lat: 44.9537,
      lon: -93.0900
    },
    phone: '6125559876',
    services: ['Transmission Repair', 'AC Service', 'Tire Service'],
    status: 'Inactive',
    isSelected: false
  },
  {
    id: 'V003',
    name: 'Speedy Auto Repair',
    providerId: 'P003',
    specialityCodeSvc: 'BATTERY',
    taxIdentificationNbr: 345678901,
    tiesId: 765432109,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V003',
    vendorTypeCode: 11,
    vendorSpecializations: 'Quick Service and Battery Replacement',
    address: {
      street: '789 Pine St',
      city: 'Bloomington',
      state: 'MN',
      zipCode: '55420'
    },
    coordinates: {
      lat: 44.8408,
      lon: -93.2982
    },
    phone: '9525554567',
    services: ['Oil Change', 'Battery Service', 'Brake Repair'],
    status: 'Active',
    isSelected: false
  },
  // Idaho Vendors
  {
    id: 'V004',
    name: 'ABRA - Post Falls',
    providerId: 'P004',
    specialityCodeSvc: 'COLLISION',
    taxIdentificationNbr: 456789012,
    tiesId: 654321098,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V004',
    vendorTypeCode: 11,
    vendorSpecializations: 'Collision Repair',
    address: {
      street: '1900 E Polston Avenue',
      city: 'Post Falls',
      state: 'ID',
      zipCode: '83854'
    },
    coordinates: {
      lat: 47.7177,
      lon: -116.9516
    },
    phone: '2087739782',
    services: ['Collision Repair', 'Paint Service', 'Frame Straightening'],
    status: 'Active',
    isSelected: false
  },
  {
    id: 'V005',
    name: 'ABRA - Boise Downtown',
    providerId: 'P005',
    specialityCodeSvc: 'COLLISION',
    taxIdentificationNbr: 567890123,
    tiesId: 543210987,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V005',
    vendorTypeCode: 11,
    vendorSpecializations: 'Collision Repair',
    address: {
      street: '1250 S Capitol Blvd',
      city: 'Boise',
      state: 'ID',
      zipCode: '83706'
    },
    coordinates: {
      lat: 43.6150,
      lon: -116.2023
    },
    phone: '2085551234',
    services: ['Collision Repair', 'Dent Removal', 'Glass Repair'],
    status: 'Active',
    isSelected: false
  },
  // Georgia Vendors
  {
    id: 'V006',
    name: 'ServiceMaster Auto',
    providerId: 'P006',
    specialityCodeSvc: 'GENERAL',
    taxIdentificationNbr: 678901234,
    tiesId: 432109876,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V006',
    vendorTypeCode: 11,
    vendorSpecializations: 'General Auto Repair',
    address: {
      street: '791 Joe Frank Harris Parkway',
      city: 'Cartersville',
      state: 'GA',
      zipCode: '30120'
    },
    coordinates: {
      lat: 34.1651,
      lon: -84.7999
    },
    phone: '8007377663',
    services: ['General Repair', 'Maintenance', 'Inspection'],
    status: 'Active',
    isSelected: false
  },
  {
    id: 'V007',
    name: 'Master Auto Services',
    providerId: 'P007',
    specialityCodeSvc: 'SPECIALTY',
    taxIdentificationNbr: 789012345,
    tiesId: 321098765,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V007',
    vendorTypeCode: 11,
    vendorSpecializations: 'Specialty Auto Repair',
    specialty: '763',
    address: {
      street: '20 Heatco Ct, STE 200',
      city: 'Cartersville',
      state: 'GA',
      zipCode: '30120'
    },
    coordinates: {
      lat: 34.1651,
      lon: -84.7999
    },
    phone: '6787198706',
    services: ['Specialty Repair', 'Custom Work', 'Performance Tuning'],
    status: 'Active',
    isSelected: false
  },
  // Utah Vendors
  {
    id: 'V008',
    name: 'Caliber Collision - American Fork',
    providerId: 'P008',
    specialityCodeSvc: 'COLLISION',
    taxIdentificationNbr: 890123456,
    tiesId: 210987654,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V008',
    vendorTypeCode: 11,
    vendorSpecializations: 'Collision Repair',
    address: {
      street: '62 North 1020 West',
      city: 'American Fork',
      state: 'UT',
      zipCode: '84003'
    },
    coordinates: {
      lat: 40.3769,
      lon: -111.7957
    },
    phone: '8016101028',
    services: ['Collision Repair', 'Paint Service', 'Insurance Claims'],
    status: 'Active',
    isSelected: false
  },
  {
    id: 'V009',
    name: 'Caliber Collision - Salt Lake City',
    providerId: 'P009',
    specialityCodeSvc: 'COLLISION',
    taxIdentificationNbr: 901234567,
    tiesId: 109876543,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V009',
    vendorTypeCode: 11,
    vendorSpecializations: 'Collision Repair',
    address: {
      street: '1550 S State St',
      city: 'Salt Lake City',
      state: 'UT',
      zipCode: '84115'
    },
    coordinates: {
      lat: 40.7366,
      lon: -111.8883
    },
    phone: '8015551234',
    services: ['Collision Repair', 'Frame Work', 'Paint Matching'],
    status: 'Active',
    isSelected: false
  },
  // California Vendors
  {
    id: 'V010',
    name: 'Master Automotive - Los Angeles',
    providerId: 'P010',
    specialityCodeSvc: 'GENERAL',
    taxIdentificationNbr: 112233445,
    tiesId: 998877665,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V010',
    vendorTypeCode: 11,
    vendorSpecializations: 'General Auto Repair',
    address: {
      street: '1500 Wilshire Blvd',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90017'
    },
    coordinates: {
      lat: 34.0522,
      lon: -118.2437
    },
    phone: '2135551234',
    services: ['General Repair', 'Diagnostics', 'Maintenance'],
    status: 'Active',
    isSelected: false
  },
  // Texas Vendors
  {
    id: 'V011',
    name: 'Elite Auto Repair - Dallas',
    providerId: 'P011',
    specialityCodeSvc: 'SPECIALTY',
    taxIdentificationNbr: 223344556,
    tiesId: 887766554,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V011',
    vendorTypeCode: 11,
    vendorSpecializations: 'Specialty Auto Services',
    address: {
      street: '2500 N Central Expressway',
      city: 'Dallas',
      state: 'TX',
      zipCode: '75201'
    },
    coordinates: {
      lat: 32.7767,
      lon: -96.7970
    },
    phone: '2145551234',
    services: ['Specialty Repair', 'European Vehicles', 'Import Services'],
    status: 'Active',
    isSelected: false
  },
  // Florida Vendors
  {
    id: 'V012',
    name: 'Quick Fix Auto - Miami',
    providerId: 'P012',
    specialityCodeSvc: 'QUICK_SERVICE',
    taxIdentificationNbr: 334455667,
    tiesId: 776655443,
    /* appraisalSoftware1: [
      {
        "appraisalSoftwareKey": "AS-MITCHELL-001",
        "appraisalSoftwareCd": "MITCH"
      }
    ], */
    appraisalSoftware1: '',
    appraisalSoftware2: '',
    suppressionIndicator: 'N',
    suppressionComment: 'No comments',
    vendorId: 'V012',
    vendorTypeCode: 11,
    vendorSpecializations: 'Quick Service',
    address: {
      street: '1200 Brickell Ave',
      city: 'Miami',
      state: 'FL',
      zipCode: '33131'
    },
    coordinates: {
      lat: 25.7617,
      lon: -80.1918
    },
    phone: '3055551234',
    services: ['Oil Change', 'Quick Service', 'Tire Rotation'],
    status: 'Active',
    isSelected: false
  },
  // New York Vendors
  // {
  //   id: 'V013',
  //   name: 'Metro Auto Repair',
  //   providerId: 'P013',
  //   specialityCodeSvc: 'GENERAL',
  //   taxIdentificationNbr: 445566778,
  //   tiesId: 665544332,
  //     /* appraisalSoftware1: [
  //       {
  //         "appraisalSoftwareKey": "AS-MITCHELL-001",
  //         "appraisalSoftwareCd": "MITCH"
  //       }
  //     ], */
  //   suppressionIndicator: 'N',
  //   suppressionComment: 'No comments',
  //   vendorId: 'V013',
  //   vendorTypeCode: 11,
  //   vendorSpecializations: 'General Auto Repair',
  //   address: {
  //     street: '350 5th Ave',
  //     city: 'New York',
  //     state: 'NY',
  //     zipCode: '10118'
  //   },
  //   coordinates: {
  //     lat: 40.7484,
  //     lon: -73.9857
  //   },
  //   phone: '2125551234',
  //   services: ['General Repair', 'Brake Service', 'Exhaust Work'],
  //   status: 'Active',
  //   isSelected: false
  // },
  // // Illinois Vendors
  // {
  //   id: 'V014',
  //   name: 'Windy City Auto',
  //   providerId: 'P014',
  //   specialityCodeSvc: 'COLLISION',
  //   taxIdentificationNbr: 556677889,
  //   tiesId: 554433221,
  //     /* appraisalSoftware1: [
  //       {
  //         "appraisalSoftwareKey": "AS-MITCHELL-001",
  //         "appraisalSoftwareCd": "MITCH"
  //       }
  //     ], */
  //   suppressionIndicator: 'N',
  //   suppressionComment: 'No comments',
  //   vendorId: 'V014',
  //   vendorTypeCode: 11,
  //   vendorSpecializations: 'Collision Repair',
  //   address: {
  //     street: '500 W Madison St',
  //     city: 'Chicago',
  //     state: 'IL',
  //     zipCode: '60661'
  //   },
  //   coordinates: {
  //     lat: 41.8781,
  //     lon: -87.6298
  //   },
  //   phone: '3125551234',
  //   services: ['Collision Repair', 'Body Work', 'Paint Service'],
  //   status: 'Active',
  //   isSelected: false
  // },
  // // Washington Vendors
  // {
  //   id: 'V015',
  //   name: 'Pacific Auto Services',
  //   providerId: 'P015',
  //   specialityCodeSvc: 'GENERAL',
  //   taxIdentificationNbr: 667788990,
  //   tiesId: 443322110,
  //     /* appraisalSoftware1: [
  //       {
  //         "appraisalSoftwareKey": "AS-MITCHELL-001",
  //         "appraisalSoftwareCd": "MITCH"
  //       }
  //     ], */
  //   suppressionIndicator: 'N',
  //   suppressionComment: 'No comments',
  //   vendorId: 'V015',
  //   vendorTypeCode: 11,
  //   vendorSpecializations: 'General Auto Repair',
  //   address: {
  //     street: '1200 Pike St',
  //     city: 'Seattle',
  //     state: 'WA',
  //     zipCode: '98101'
  //   },
  //   coordinates: {
  //     lat: 47.6062,
  //     lon: -122.3321
  //   },
  //   phone: '2065551234',
  //   services: ['General Repair', 'Maintenance', 'Diagnostics'],
  //   status: 'Active',
  //   isSelected: false
  // }
];

// In mockVendors.ts - Add property vendors

export const mockPropertyVendors: PropertyVendor[] = [
  {
    id: "V-10045",
    name: "Premier Restoration Services",
    dba: "Premier Restoration",
    taxIdTin: 123456789,
    providerId: "PRS-2023",
    status: "A",
    adminComments: "Active, Preferred vendor for water damage, Fast response time",
    approvalStatus: "APPROVED",
    vendorId: "V-10045",
    vendorTypeCode: "60",
    key: false,
    notes: "only uses in wifi",
    yearsInBusiness: 15,
    phone: "555-123-4567",
    principalOwner: "Sarah Johnson",
    franchiseId: "FR-9087",
    address: {
      street: '789 Pine St',
      city: 'Bloomington',
      state: 'MN',
      zipCode: '55420'
    },
    // primaryCounty: "Denver",
    coordinates: {
      lat: 44.8408, lon: -93.2982
    },
    mailingAddress: {
      street: "1234 Restor",
      city: "DC",
      state: "CO",
      zipCode: "80202"
    },
    providerContactName: "Michael Thompson",
    providerContactEmail: "mthompson@premierrestoration.com",
    additionalContactName: "Jennifer Davis",
    afterHoursPhone: "555-987-6543",
    credentialProviderContactName: "Robert Wilson",
    credentialProviderContactEmail: "rwilson@premierrestoration.com",
    localLicense: "DEN-REST-2023",
    localLicenseComment: "Denver Metro Area License",
    stateLicense: "CO-REST-45678",
    stateLicenseComment: "Colorado State Restoration License",
    serviceArea: 'Nationwide',
    serviceCodes: "600,605,601",
    otherServices: "Emergency Board-up, Mold Remediation, Smoke Damage Cleanup",
    subcontractorUsage: "70",
    warrantyPeriod: 12,
    twentyFourHourResponse: "Yes",
    customerNetworkCodes: "MCU",
    claimCenter: "HTFD",
    preferredProviderStatus: "Yes",
    warrentyMonths: 12,
    isSelected: false,
    // additionalComments: "One ring to rule them all"
  },
  {
    id: "V-20056",
    name: "Elite Property Services",
    dba: "Elite Property",
    taxIdTin: 987654321,
    providerId: "EPS-2022",
    status: "I",
    adminComments: "Active, Good quality work, Reliable service",
    approvalStatus: "CONTRACT",
    vendorId: "V-20056",
    vendorTypeCode: "60",
    key: false,
    notes: "uses in AZ",
    yearsInBusiness: 10,
    phone: "555-234-5678",
    principalOwner: "Thomas Garcia",
    franchiseId: "FR-1234",
    address: {
      street: "456 Oak Ave",
      city: "Phoenix",
      state: "AZ",
      zipCode: "85001"
    },
    // primaryCounty: "Maricopa",
    coordinates: { lat: 33.4484, lon: -112.0740 },
    mailingAddress: { street: "456 Oak Ave", city: "Phoenix", state: "AZ", zipCode: "85001" },
    providerContactName: "Thomas Garcia",
    providerContactEmail: "tgarcia@elitepropertyservices.com",
    additionalContactName: "Linda Martinez",
    afterHoursPhone: "555-222-3333",
    credentialProviderContactName: "Thomas Garcia",
    credentialProviderContactEmail: "tgarcia@elitepropertyservices.com",
    localLicense: "PHX-REST-7890",
    localLicenseComment: "Phoenix Metropolitan License",
    stateLicense: "AZ-REST-12345",
    stateLicenseComment: "Arizona State Restoration License",
    serviceArea: "Statewide",
    stateServiceAreas: ["AZ", "NV", "CA"],
    // serviceAreasStates: ["AZ", "NV", "CA"],
    // serviceAreasCounties: ["MAR_AZ", "CLA_NV", "LAC_CA"],
    // serviceAreasZipcodes: ["85001-85099", "89101-89199"],
    // areasWorkedIn: ["Phoenix Metro", "Las Vegas", "Southern California"],
    serviceCodes: "602,608,603,609",
    otherServices: "Storm Damage Repair, Structural Drying, Contents Restoration",
    subcontractorUsage: "65",
    twentyFourHourResponse: "Yes",
    warrantyPeriod: 24,
    customerNetworkCodes: "MCUPI",
    claimCenter: "FLD",
    preferredProviderStatus: "Yes",
    warrentyMonths: 24,
    isSelected: false,
    // additionalComments: "one ring to find"
  },
  {
    id: "V-30078",
    name: "Rapid Response Restoration",
    dba: "RRR",
    taxIdTin: 456789123,
    providerId: "RRR-3045",
    status: "A",
    adminComments: "Active",
    approvalStatus: "LAB_INLAND",
    vendorId: "V-30078",
    vendorTypeCode: "60",
    key: true,
    notes: "only uses in MN",
    yearsInBusiness: 22,
    phone: "555-345-6789",
    principalOwner: "James Wilson",
    franchiseId: "FR-4532",

    address: {
      street: "789 Emergency Road",
      city: "Chicago",
      state: "IL",
      zipCode: "60601"
    },
    // primaryCounty: "Cook",

    coordinates: {
      lat: 41.8781,
      lon: -87.6298
    },

    mailingAddress: {
      street: "789 Emergency Road",
      city: "Chicago",
      state: "IL",
      zipCode: "60601"
    },

    providerContactName: "Patricia Brown",
    providerContactEmail: "pbrown@rapidresponse.com",
    additionalContactName: "Kevin Smith",
    afterHoursPhone: "555-111-2222",

    credentialProviderContactName: "Michelle Lee",
    credentialProviderContactEmail: "mlee@rapidresponse.com",

    localLicense: "CHI-REST-5678",
    stateLicense: "IL-REST-98765",
    stateLicenseComment: "Illinois State Restoration License with Special Certifications",

    serviceArea: "CountyWide",
    countyState: "Minnesota",
    countyServiceArea: ["Hennyah", "Ramsey", "Dakota"],
    // nationwide: "Yes",
    // serviceAreasStates: ["CA", "NY", "TX", "FL", "IL"],
    // serviceAreasCounties: ["COO_IL", "KIN_NY", "LAC_CA", "MIA_FL", "DAL_TX"],
    // serviceAreasZipcodes: ["60601-60699", "10001-10099", "90001-90099", "33101-33199", "75201-75299"],
    // areasWorkedIn: [],

    serviceCodes: "600,605,606,607,608",
    otherServices: "Catastrophe Response, Large Loss Handling, Commercial Restoration",

    subcontractorUsage: "50",
    twentyFourHourResponse: "Yes",
    warrantyPeriod: 36,

    customerNetworkCodes: "MUCBI",
    claimCenter: "HOMOFFC",

    preferredProviderStatus: "Yes",
    warrentyMonths: 36,

    yearEstablished: 2000,
    serviceAreaType: "National",

    isSelected: false,
    // additionalComments:"I have the high ground"
  },
  {
    id: "V-40023",
    name: "Local Property Experts",
    dba: "LPE Restoration",
    taxIdTin: 234567890,
    providerId: "LPE-5067",
    status: "O",
    adminComments: "Supressed - Only uses in MN",
    approvalStatus: "MCU_APPROVED",
    vendorId: "V-40023",
    vendorTypeCode: "60",
    key: false,
    notes: "only uses in MN",
    yearsInBusiness: 3,
    phone: "555-456-7890",
    principalOwner: "Emily Chen",
    franchiseId: "",

    address: {
      street: "456 Main Street",
      city: "Portland",
      state: "OR",
      zipCode: "97201"
    },
    // primaryCounty: "Multnomah",

    coordinates: {
      lat: 45.5231,
      lon: -122.6765
    },

    mailingAddress: {
      street: "456 Main Street",
      city: "Portland",
      state: "OR",
      zipCode: "97201"
    },

    providerContactName: "Daniel Park",
    providerContactEmail: "dpark@localpropertyexperts.com",

    localLicense: "PDX-REST-3456",

    serviceArea: "ZipWide",
    zipServiceAreas: ["97201-9729", "98101-9819"],

    serviceCodes: "605,608",
    otherServices: "Residential Restoration, Small Business Recovery",

    subcontractorUsage: "35",
    twentyFourHourResponse: "No",

    customerNetworkCodes: "SVCNT",
    claimCenter: "LKMI",

    preferredProviderStatus: "No",

    yearEstablished: 2020,
    serviceAreaType: "Local",

    isSelected: false,
    // additionalComments: "You were the chosen one!"
  },
  {
    id: "V-50034",
    name: "Southern Comfort Restoration",
    dba: "SC Restoration",
    taxIdTin: 345678901,
    providerId: "SCR-7089",
    status: "A",
    adminComments: "Active",
    approvalStatus: "APPROVED",
    vendorId: "V-50034",
    vendorTypeCode: "60",
    key: false,
    notes: "only uses in wifi",
    yearsInBusiness: 12,
    phone: "555-567-8901",
    principalOwner: "Robert Johnson",
    franchiseId: "FR-7654",

    address: {
      street: "890 Bayou Drive",
      city: "New Orleans",
      state: "LA",
      zipCode: "70112"
    },
    // primaryCounty: "Orleans",

    coordinates: {
      lat: 29.9511,
      lon: -90.0715
    },

    mailingAddress: {
      street: "890 Bayou Drive",
      city: "New Orleans",
      state: "LA",
      zipCode: "70112"
    },

    providerContactName: "Alicia Washington",
    providerContactEmail: "awashington@screstoration.com",
    additionalContactName: "Marcus Taylor",
    afterHoursPhone: "555-444-3333",

    credentialProviderContactName: "Jasmine Williams",
    credentialProviderContactEmail: "jwilliams@screstoration.com",

    localLicense: "NOLA-REST-6789",
    localLicenseComment: "New Orleans Metropolitan Area",
    stateLicense: "LA-REST-54321",
    stateLicenseComment: "Louisiana State License with Flood Specialization",

    // 
    serviceArea: "Nationwide",

    serviceCodes: "600,605,606,609",
    otherServices: "Hurricane Damage Repair, Flood Restoration, Historic Property Restoration",

    subcontractorUsage: "90",
    twentyFourHourResponse: "Yes",
    warrantyPeriod: 18,

    customerNetworkCodes: "MRP",
    claimCenter: "MCU",

    preferredProviderStatus: "Yes",
    warrentyMonths: 18,

    yearEstablished: 2010,
    serviceAreaType: "Regional",

    isSelected: false,
    // additionalComments: "May the force be with you"
  },
  {
    id: "V-60045",
    name: "Pacific Northwest Restoration",
    dba: "PNW Restore",
    taxIdTin: 456789012,
    providerId: "PNW-8090",
    status: "I",
    adminComments: "Active, Specializes in water damage",
    approvalStatus: "CONTRACT",
    vendorId: "V-60045",
    vendorTypeCode: "60",
    key: false,
    notes: "Covers WA, OR, ID",
    yearsInBusiness: 8,
    phone: "5556781234",
    principalOwner: "Amanda Lewis",
    franchiseId: "FR-2345",
    address: {
      street: "1500 Pike Place",
      city: "Seattle",
      state: "WA",
      zipCode: "98101"
    },
    // primaryCounty: "King",
    coordinates: { lat: 47.6062, lon: -122.3321 },
    mailingAddress: { street: "1500 Pike Place", city: "Seattle", state: "WA", zipCode: "98101" },
    providerContactName: "Amanda Lewis",
    providerContactEmail: "alewis@pnwrestore.com",
    additionalContactName: "Brian Carter",
    afterHoursPhone: "5556785678",
    credentialProviderContactName: "Amanda Lewis",
    credentialProviderContactEmail: "alewis@pnwrestore.com",
    localLicense: "SEA-REST-4567",
    stateLicense: "WA-REST-23456",
    serviceArea: "ZipWide",
    zipServiceAreas: ["98001-9819", "97001-9729"],
    // nationwide: "No",
    // serviceAreasStates: ["WA", "OR", "ID"],
    // serviceAreasCounties: ["KIN_WA", "MUL_OR"],
    // serviceAreasZipcodes: ["98001-98199", "97001-97299"],
    // areasWorkedIn: ["Seattle Metro", "Portland", "Spokane"],
    serviceCodes: "600,605",
    otherServices: "Water Damage, Mold Remediation",
    subcontractorUsage: "45",
    twentyFourHourResponse: "Yes",
    warrantyPeriod: 12,
    customerNetworkCodes: "DRP",
    claimCenter: "MCUBI",
    preferredProviderStatus: "Yes",
    warrentyMonths: 12,
    isSelected: false,
    // additionalComments: "Strong regional presence"
  },
  {
    id: "V-70056",
    name: "Mountain States Property Services",
    dba: "Mountain States",
    taxIdTin: 567890123,
    providerId: "MSP-9101",
    status: "A",
    adminComments: "Active",
    approvalStatus: "LAB_INLAND",
    vendorId: "V-70056",
    vendorTypeCode: "60",
    key: true,
    notes: "Mountain region specialist",
    yearsInBusiness: 18,
    phone: "5557891234",
    principalOwner: "Christopher Davis",
    franchiseId: "FR-6789",
    address: {
      street: "3400 Mountain View Dr",
      city: "Denver",
      state: "CO",
      zipCode: "80202"
    },
    // primaryCounty: "Denver",
    coordinates: { lat: 39.7392, lon: -104.9903 },
    mailingAddress: { street: "3400 Mountain View Dr", city: "Denver", state: "CO", zipCode: "80202" },
    providerContactName: "Christopher Davis",
    providerContactEmail: "cdavis@mountainstates.com",
    afterHoursPhone: "5557895678",
    credentialProviderContactName: "Susan Miller",
    credentialProviderContactEmail: "smiller@mountainstates.com",
    localLicense: "DEN-REST-7890",
    stateLicense: "CO-REST-67890",
    serviceArea: "Statewide",
    stateServiceAreas: ["CO", "WY", "MT"],
    // nationwide: "No",
    // serviceAreasStates: ["CO", "WY", "MT"],
    // serviceAreasCounties: ["DEN_CO", "LAR_WY"],
    // serviceAreasZipcodes: ["80001-80299", "82001-82099"],
    // areasWorkedIn: ["Denver Metro", "Boulder", "Fort Collins"],
    serviceCodes: "600,605,606",
    otherServices: "Snow Damage Repair, High Altitude Restoration",
    subcontractorUsage: "55",
    twentyFourHourResponse: "Yes",
    warrantyPeriod: 18,
    customerNetworkCodes: "MIT",
    claimCenter: "MCUPI",
    preferredProviderStatus: "Yes",
    warrentyMonths: 18,
    isSelected: false,
    // additionalComments: "Handles high-altitude challenges"
  },
  {
    id: "V-80067",
    name: "Sunshine State Restoration",
    dba: "Sunshine Restore",
    taxIdTin: 678901234,
    providerId: "SSR-2112",
    status: "Active",
    adminComments: "Active, Hurricane specialist",
    approvalStatus: "MCU_APPROVED",
    vendorId: "V-80067",
    vendorTypeCode: "60",
    key: false,
    notes: "Hurricane damage expert",
    yearsInBusiness: 20,
    phone: "5558901234",
    principalOwner: "Carlos Rodriguez",
    franchiseId: "FR-3456",
    address: {
      street: "2800 Ocean Drive",
      city: "Miami",
      state: "FL",
      zipCode: "33139"
    },
    // primaryCounty: "Miami-Dade",
    coordinates: { lat: 25.7617, lon: -80.1918 },
    mailingAddress: { street: "2800 Ocean Drive", city: "Miami", state: "FL", zipCode: "33139" },
    providerContactName: "Carlos Rodriguez",
    providerContactEmail: "crodriguez@sunshinerest.com",
    additionalContactName: "Diana Fernandez",
    afterHoursPhone: "5558905678",
    credentialProviderContactName: "Carlos Rodriguez",
    credentialProviderContactEmail: "crodriguez@sunshinerest.com",
    localLicense: "MIA-REST-8901",
    stateLicense: "FL-REST-78901",
    serviceArea: "CountyWide",
    countyState: "Florida",
    countyServiceArea: ["Miami-Dade", "Broward", "Palm Beach"],
    // nationwide: "No",
    // serviceAreasStates: ["FL"],
    // serviceAreasCounties: ["MIA_FL", "BRO_FL"],
    // serviceAreasZipcodes: ["33001-33299"],
    // areasWorkedIn: ["Miami Metro", "Fort Lauderdale", "West Palm Beach"],
    serviceCodes: "600,605,609",
    otherServices: "Hurricane Recovery, Storm Surge Cleanup",
    subcontractorUsage: "75",
    twentyFourHourResponse: "Yes",
    warrantyPeriod: 12,
    customerNetworkCodes: "PRF",
    claimCenter: "METRONYNJ",
    preferredProviderStatus: "Yes",
    warrentyMonths: 12,
    isSelected: false,
    // additionalComments: "24/7 hurricane response team"
  },
  {
    id: "V-90078",
    name: "Midwest Property Solutions",
    dba: "Midwest Solutions",
    taxIdTin: 789012345,
    providerId: "MPS-3123",
    status: "O",
    adminComments: "Supressed - Limited to MN",
    approvalStatus: "APPROVED",
    vendorId: "V-90078",
    vendorTypeCode: "60",
    key: false,
    notes: "Minnesota only",
    yearsInBusiness: 6,
    phone: "5559012345",
    principalOwner: "Jessica Anderson",
    franchiseId: "",
    address: {
      street: "4200 Nicollet Ave",
      city: "Minneapolis",
      state: "MN",
      zipCode: "55409"
    },
    // primaryCounty: "Hennepin",
    coordinates: { lat: 44.9778, lon: -93.2650 },
    mailingAddress: { street: "4200 Nicollet Ave", city: "Minneapolis", state: "MN", zipCode: "55409" },
    providerContactName: "Jessica Anderson",
    providerContactEmail: "janderson@midwestsolutions.com",
    localLicense: "MSP-REST-9012",
    stateLicense: "MN-REST-89012",
    serviceArea: "CountyWide",
    countyState: "Minnesota",
    countyServiceArea: ["Hennepin", "Ramsey"],
    // nationwide: "No",
    // serviceAreasStates: ["MN"],
    // serviceAreasCounties: ["HEN_MN", "RAM_MN"],
    // serviceAreasZipcodes: ["55001-55199"],
    // areasWorkedIn: ["Minneapolis", "St. Paul", "Bloomington"],
    serviceCodes: "605,608",
    otherServices: "Cold Weather Restoration, Ice Dam Removal",
    subcontractorUsage: "40",
    twentyFourHourResponse: "No",
    customerNetworkCodes: "MCU",
    claimCenter: "MDAT",
    preferredProviderStatus: "No",
    isSelected: false,
    // additionalComments: "Cold weather specialists"
  }
];
